import PopupWrapper from "../popupWrapper/popupWrapper";
import { popupTexts } from "../../utils/constants";
import "./deletePopup.css";
import { useDispatch } from "react-redux";
import { deletePlanAsync } from "../../redux/reducers/plansSlice";
import { useLocation } from "react-router-dom";
import { deleteDeviceAsync } from "../../redux/reducers/devicesSlice";
import { deleteAddonAsync } from "../../redux/reducers/addonsSlice";

const DeletePopup = ({ onClose, id, name, refreshList }) => {
  const dispatch = useDispatch();
  const url = useLocation();
  const handleDelete = () => {
    const deleteActions = {
      "/plans": deletePlanAsync,
      "/devices": deleteDeviceAsync,
      "/addons": deleteAddonAsync,
    };

    const deleteAction = deleteActions[url?.pathname];
    if (deleteAction) {
      dispatch(deleteAction(id)).then(() => {
        onClose();
        refreshList();
      });
    }
  };

  return (
    <PopupWrapper className="accept_popup" onClose={onClose}>
      <p className="delete_header">{popupTexts.delete_header}</p>
      <p className="delete_subheader">
        {popupTexts.delete_subheader} {name}?
      </p>
      <div className="button_section">
        <button className="button reject reject_btn " onClick={onClose}>
          {popupTexts.cancel_btn}
        </button>
        <button className="button accept accept_btn " onClick={handleDelete}>
          {popupTexts.confirm_btn}
        </button>
      </div>
    </PopupWrapper>
  );
};

export default DeletePopup;
